module.exports = __webpack_public_path__ + "img/nursena.a81260f3.jpg";